/* eslint-disable @typescript-eslint/no-unused-vars */
import { Panel as Panel_ } from './panel';

export namespace Enterprise {
  export import Panel = Panel_;
}
